import React from 'react';
import CreatedBooking from '../../../types/CreatedBooking';
import CreatedBookingItem from './CreatedBookingItem';
import EmptyListButton from './EmptyListButton';

interface CreatedBookingItemListProps {
  bookings: CreatedBooking[];
  onCancelBooking: Function;
  onRemoveEntry: Function;
  onRemoveAllEntries: Function;
}

const CreatedBookingItemList : React.FC<CreatedBookingItemListProps> = ({ bookings, onCancelBooking, onRemoveEntry, onRemoveAllEntries }) => {
  return (
    <div data-testid="booking-references" className="h-full flex flex-col overflow-y-hidden bg-white rounded-lg shadow-lg py-4 pl-4">
      <h2 className="text-xl font-bold mb-2">Created Bookings</h2>
      <ul className="list-inside text-left flex-grow overflow-y-auto [scrollbar-gutter:stable]">
        {bookings.map((booking, index) => ( 
          <CreatedBookingItem 
            key={index}
            reference={booking.reference}
            cancelled={booking.cancelled}
            productClass={booking.productClass}
            bookingCategory={booking.bookingCategory}
            onCancelBooking={onCancelBooking}
            onRemoveEntry={onRemoveEntry}
             />
        ))}
      </ul>
      <div className="flex justify-space-between mt-2 pr-4">
        {bookings.length > 0 ? <EmptyListButton onRemoveAllEntries={onRemoveAllEntries} /> : null}
      </div>
    </div>
  );
};

export default CreatedBookingItemList;